import React, { useEffect, useState } from 'react'
import '../About/About.css';
import './Menu_Page.css';
import Footer from "../Footer/Footer";
import MenuSectionOne from './Images/Menu_section_one.png'
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { FaLeaf, FaUtensils, FaIceCream } from "react-icons/fa6";
import { buildApiUrl } from '../../config/api.config';

const Menu_Page = ({showAlert}) => {
  const [userDetails, setUserDetails] = useState({ name: "", email: "", id: "" });
  const [foodList, setFoodList] = useState([]);
  const [loading, setLoading] = useState(true);
  let navigate = useNavigate();

  const fetchUserDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return null;
      
      const response = await fetch(buildApiUrl("/users/getuser"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      });
      
      if (response.ok) {
        return await response.json();
      }
      return null;
    } catch (error) {
      console.error("Error fetching user details:", error.message);
      return null;
    }
  };

  const fetchFoodList = async () => {
    try {
      const uDetails = JSON.parse(localStorage.getItem("userDetails"));
      const selectedRestId = localStorage.getItem("currentRestaurantId");
      let activeRestaurantId = (uDetails?.role === 'owner' || uDetails?.role === 'user') ? selectedRestId : uDetails?.restaurantId;

      // Handle populated restaurantId object
      if (activeRestaurantId && typeof activeRestaurantId === 'object') {
          activeRestaurantId = activeRestaurantId._id;
      }

      if (!activeRestaurantId) {
        setFoodList([]);
        setLoading(false);
        return;
      }

      const response = await axios.get(buildApiUrl(`/food/list?restaurantId=${activeRestaurantId}`));
      setFoodList(response.data.data);
    } catch (error) {
      console.error("Error fetching food list:", error);
      showAlert("Error fetching food list", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const getUserDetails = async () => {
      const userData = await fetchUserDetails();
      if(localStorage.getItem("token")){
        setUserDetails(userData);
      }else{
        navigate("/login");
      }
      if (userData) {
        setUserDetails(userData);
      } else {
        setUserDetails({ name: "", email: "", id: "" });
      }
    };

    getUserDetails();
    fetchFoodList();
  }, []);

  // Group food items by meal type and category
  const groupedFood = foodList.reduce((acc, item) => {
    if (!acc[item.mealType]) {
      acc[item.mealType] = {
        Starter: [],
        'Main Course': [],
        Dessert: [],
      };
    }
    if (acc[item.mealType][item.category]) {
      acc[item.mealType][item.category].push(item);
    }
    return acc;
  }, {});

  // Render menu section for a specific meal type
  const renderMealSection = (mealType) => {
    const mealData = groupedFood[mealType] || {
      Starter: [],
      'Main Course': [],
      Dessert: []
    };

    return (
      <div className="menu-time-section" key={mealType}>
        <div className="menu-time-header">
          <h2 className="meal-type-title">{mealType}</h2>
          <p className="meal-type-subtitle">Delicious {mealType.toLowerCase()} options</p>
        </div>
        
        <div className="menu-categories-grid">
          {/* Starter Section */}
          {mealData.Starter.length > 0 && (
            <div className="menu-category-card">
              <div className="category-header">
                <h3 className="category-title"><FaLeaf className="category-icon" /> Starters</h3>
              </div>
              <ul className="menu-items-list">
                {mealData.Starter.map((item, index) => (
                  <li className="menu-item" key={index}>
                    <span className="item-name">{item.name}</span>
                    <span className="item-dots"></span>
                    <span className="item-price">${item.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          {/* Main Course Section */}
          {mealData['Main Course'].length > 0 && (
            <div className="menu-category-card">
              <div className="category-header">
                <h3 className="category-title"><FaUtensils className="category-icon" /> Main Course</h3>
              </div>
              <ul className="menu-items-list">
                {mealData['Main Course'].map((item, index) => (
                  <li className="menu-item" key={index}>
                    <span className="item-name">{item.name}</span>
                    <span className="item-dots"></span>
                    <span className="item-price">${item.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          
          {/* Dessert Section */}
          {mealData.Dessert.length > 0 && (
            <div className="menu-category-card">
              <div className="category-header">
                <h3 className="category-title"><FaIceCream className="category-icon" /> Desserts</h3>
              </div>
              <ul className="menu-items-list">
                {mealData.Dessert.map((item, index) => (
                  <li className="menu-item" key={index}>
                    <span className="item-name">{item.name}</span>
                    <span className="item-dots"></span>
                    <span className="item-price">${item.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {/* Immersive Hero Section */}
      <div className="about-hero-section menu-hero-adjust">
        <div className="about-hero-overlay"></div>
        <div className="container about-hero-content">
          <div className="about-hero-text">
            <span className="about-badge">Menu</span>
            <h1 className="tf-heading-lg">Our Exclusive Picks</h1>
            <p className="about-hero-desc">
              Each item has been handpicked, blending innovation and tradition to deliver an unforgettable dining experience.
            </p>
            {userDetails.role === 'admin' ? 
              <Link to='/admin/add'>
                <button className="tf-btn tf-btn-primary tf-btn-pill mt-3">Add Menu</button>
              </Link>
              :
              <Link to='/table-reserve'>
                <button className="tf-btn tf-btn-primary tf-btn-pill mt-3">Reserve a Table</button>
              </Link>}
          </div>
          <div className="about-hero-image-wrapper">
            <div className="about-hero-glow"></div>
            <img className="about-hero-image" src={MenuSectionOne} alt="Menu Highlights" />
          </div>
        </div>
      </div>

      {/* Menu Sections */}
      <section className="menu-sections-container">
        <div className="container">
          <div className="menu-sections-wrapper">
            {['Breakfast', 'Lunch', 'Dinner'].map(mealType => (
              groupedFood[mealType] && renderMealSection(mealType)
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Menu_Page;